import { AnyAction } from 'redux';

import { driversActions } from '../reducer';

export const resetDriverLocations = (): AnyAction => driversActions.resetDriverLocations();
